var exports = {
  "M": "x2b2fbebb--10a20a--tab",
  "v": "x2b2fbebb--10a20a--active",
};

module.exports = exports;
